/**
 * Tri-state loading tracker.
 *
 * A failed fetch must render as an error with a retry, never as an empty
 * list — a schema mismatch in production once looked like an empty catalog
 * (audit 2026-08-17, OE-A06). Screens that load critical data should route
 * their loaders through `runLoad` and branch on the resulting status.
 */
export type LoadStatus = "loading" | "ready" | "error";

/**
 * Run `fn` and report the outcome through `set`.
 *
 * Non-critical side loads (badges, rates) may still use their own
 * `.catch(() => fallback)` — only data whose absence would render a false
 * empty state belongs inside `fn`.
 */
export async function runLoad(
  set: (status: LoadStatus) => void,
  fn: () => Promise<void>,
): Promise<void> {
  set("loading");
  try {
    await fn();
    set("ready");
  } catch (e) {
    console.error("load failed:", e);
    set("error");
  }
}
